module.exports = __webpack_public_path__ + "img/AP10_tlo.f4b84b8b.jpg";